// Tailles dans la scène, qui est mise à l'échelle de la place disponible
// (variable CSS `--jr-k` posée par la scène) : les cibles et les textes
// gardent au moins 44 px et 14 px RÉELS même quand la scène est réduite
// (petit écran), et grandissent avec elle (vidéo, ordinateur).

export const SCENE_TARGET = 'min-h-[max(48px,calc(44px/var(--jr-k,1)))]';
export const SCENE_TEXT = 'text-[max(17px,calc(14px/var(--jr-k,1)))]';
export const SCENE_TEXT_SMALL = 'text-[max(16px,calc(13px/var(--jr-k,1)))]';
export const SCENE_TEXT_LARGE = 'text-[max(18px,calc(15px/var(--jr-k,1)))]';
